/* eslint-disable no-console */
import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  const buildId = String(process.env.VUE_APP_BUILD_ID || '').trim();
  const swUrl = `${process.env.BASE_URL}service-worker.js${
    buildId ? `?v=${encodeURIComponent(buildId)}` : ''
  }`;
  register(swUrl, {
    ready() {
      console.log('[pwa] Service Worker ready');
    },
    registered() {
      console.log('[pwa] Service Worker registered');
    },
    cached() {
      console.log('[pwa] Content cached for offline use');
    },
    updatefound() {
      console.log('[pwa] New content downloading…');
    },
    updated() {
      console.log('[pwa] New content available; waiting for user refresh');
    },
    offline() {
      console.log('[pwa] Offline mode');
    },
    error(error) {
      console.error('[pwa] Service Worker registration error:', error);
    },
  });
}
